var React = require('react');

function Calendar3 (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1","y":"1.923","width":"12","height":"11.077","rx":"1","stroke":"#000","key":0}),React.createElement("path",{"d":"M4.692 7.452l1.669 1.856 2.947-3.693","stroke":"#020303","key":1}),React.createElement("rect",{"x":"2.846","y":"1","width":"1.846","height":".923","rx":".462","stroke":"#000","key":2}),React.createElement("rect",{"x":"9.308","y":"1","width":"1.846","height":".923","rx":".462","stroke":"#000","key":3})]);
}

Calendar3.defaultProps = {"viewBox":"0 0 14 14","fill":"none"};

module.exports = Calendar3;

Calendar3.default = Calendar3;
